// v-reveal — fades + lifts an element into view as it enters the viewport.
// Elements start hidden (.reveal) and gain .reveal-in once observed, driving the
// CSS transition in style.css. An optional delay (ms) staggers grouped items,
// e.g. v-reveal="120". Falls back to immediately visible when IntersectionObserver
// is unavailable or the user prefers reduced motion.

const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

let observer = null

function ensureObserver() {
  if (observer || typeof IntersectionObserver === 'undefined') return observer
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-in')
          observer.unobserve(entry.target)
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  )
  return observer
}

export const revealDirective = {
  mounted(el, binding) {
    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      el.classList.add('reveal-in')
      return
    }
    const delay = Number(binding.value) || 0
    if (delay) el.style.transitionDelay = `${delay}ms`
    el.classList.add('reveal')
    ensureObserver().observe(el)
  },
  unmounted(el) {
    if (observer) observer.unobserve(el)
  }
}
